import { useCallback, useEffect, useRef } from "react";
import { EMOTION_BUCKET } from "../eieConstants";

export function useEmotionThemeBridge({
  onEmotionTheme,
  stableEmotion,
  isActive,
  isCalibrationComplete,
}) {
  const onEmotionThemeRef = useRef(onEmotionTheme);
  const stableThemeCommitTimerRef = useRef(null);
  const lastAppliedStableEmotionRef = useRef(null);

  useEffect(() => {
    onEmotionThemeRef.current = onEmotionTheme;
  }, [onEmotionTheme]);

  const clearStableThemeTimer = useCallback(() => {
    if (!stableThemeCommitTimerRef.current) return;
    window.clearTimeout(stableThemeCommitTimerRef.current);
    stableThemeCommitTimerRef.current = null;
  }, []);

  useEffect(() => {
    if (!isActive || !isCalibrationComplete || !stableEmotion || !onEmotionThemeRef.current) return;
    if (stableEmotion === lastAppliedStableEmotionRef.current) return;

    clearStableThemeTimer();

    const nextEmotion = stableEmotion;
    stableThemeCommitTimerRef.current = window.setTimeout(() => {
      const bucket = EMOTION_BUCKET[nextEmotion] || "neutral";
      onEmotionThemeRef.current?.(bucket, { emotionLabel: nextEmotion });
      lastAppliedStableEmotionRef.current = nextEmotion;
      stableThemeCommitTimerRef.current = null;
    }, 700);

    return clearStableThemeTimer;
  }, [stableEmotion, isActive, isCalibrationComplete, clearStableThemeTimer]);

  useEffect(() => {
    return clearStableThemeTimer;
  }, [clearStableThemeTimer]);

  return {
    onEmotionThemeRef,
    lastAppliedStableEmotionRef,
    clearStableThemeTimer,
  };
}
